<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">保证金返还</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>提现状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-select v-model="timeType" placeholder="Select" style="width: 8em; margin-right: 8px;">
            <el-option v-for="item in timeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="success" v-loading="updateLoading" @click="batchPass()">批量通过</el-button>
          <el-button type="danger"  @click="batchReject()">批量不通过</el-button>
          <el-button type="primary"  @click="passAll()">全部通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="提交时间" v-if="checkColList.indexOf('提交时间') > -1"/>
          <el-table-column property="identityAuthTime" label="认证成功时间" v-if="checkColList.indexOf('认证成功时间') > -1"/>
          <el-table-column property="payTime" label="支付时间" v-if="checkColList.indexOf('支付时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column property="withdrawMoney" label="提现金额" v-if="checkColList.indexOf('提现金额') > -1"/>
          <el-table-column property="" label="支付宝收款信息" v-if="checkColList.indexOf('支付宝收款信息') > -1">
            <template #default="scope">
              <p>{{scope.row.alipayName}}</p>
              <p>{{scope.row.alipayAccount}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="提现状态" v-if="checkColList.indexOf('提现状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state == 1 ? '待审核' : scope.row.state == 2 ? '已通过' : scope.row.state == 3 ? '不通过' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getBaoApplyPageList,
  updateBaoApplyState
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {auth, common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import DepositRejectDialog from "@/views/fee/components/DepositRejectDialog";
import PassAllDialog from "@/views/fee/components/PassAllDialog";

export default {
  name: "FeeDeposit",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //分状态
      stateArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '不通过', value: 3}
      ],
      state: 1,

      //时间
      timeTypeArray: [
        {label: '提交时间', value: 1},
        {label: '认证成功时间', value: 2},
        {label: '支付时间', value: 3}
      ],
      timeType: 1,

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[3]['value'],

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['提交时间', '认证成功时间', '支付时间', '头像', '用户信息', '身份认证总状态', '提现金额', '支付宝收款信息', '提现状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.state = 1;
      this.timeType = 1;
      this.overallAuthState = 2;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['timeType'] = this.timeType;
      param['overallAuthState'] = this.overallAuthState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getBaoApplyPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },


    //批量审核
    batchPass() {
      if(this.idArray.length > 0) {
        this.$confirm('请确认是否批量归还保证金？').then(()=>{
          this.updateLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = 2;
          postFormData(updateBaoApplyState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.updateLoading = false;
          })
              .catch(()=>{
                _this.updateLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //批量审核
    batchReject() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '不通过原因',
          component: DepositRejectDialog,
          data: {
            idArray: this.idArray
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++){
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0){
              this.getPage();
            }
          }
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    passAll() {
      Dialog.open({
        title: '请确认数据',
        component: PassAllDialog,
        data: {
          idArray: this.idArray,
          width: '500px'
        },
        confirm: () => {
          this.getPage();
        }
      })
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
